import { render } from "./ordentrabajoresultadoestudio.vue?vue&type=template&id=67f05e88&scoped=true"
import script from "./ordentrabajoresultadoestudio.vue?vue&type=script&lang=js"
export * from "./ordentrabajoresultadoestudio.vue?vue&type=script&lang=js"

import "./ordentrabajoresultadoestudio.vue?vue&type=style&index=0&id=67f05e88&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f05e88"]])

export default __exports__